import { Action, Dispatch } from 'redux';

export const externalResourceMiddleware = () => (next: Dispatch) => (
  action: Action & { payload?: { url?: string }; meta?: { externalResource: { open: boolean; target?: string } } },
) => {
  const isLink =
    action.payload &&
    action.payload.url &&
    typeof action.payload.url === 'string' &&
    /^https?:\/\//.test(action.payload.url);
  const shouldOpen = action.meta && action.meta.externalResource && action.meta.externalResource.open;

  if (isLink && shouldOpen) {
    return window.open(action.payload.url, action.meta.externalResource.target || '_blank');
  }

  return next(action);
};
